export const checkboxStyle = {
  label: {
    whiteSpace: "normal",
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: "1.25rem",
  },
};
